import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CelebrationOutlinedIcon from "@mui/icons-material/CelebrationOutlined";

export const CONGRATULATIONS_MESSAGE =
  "Congratulations! 🎉 You completed all Due Today projects.";

const DueTodayCongratulationsDialog = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 2,
        textAlign: "center",
      },
    }}
  >
    <DialogTitle sx={{ position: "relative", pb: 1 }}>
      Congratulations!
      <IconButton
        onClick={onClose}
        aria-label="close"
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "grey.500",
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          py: 1,
        }}
      >
        <CelebrationOutlinedIcon
          sx={{ fontSize: 56, color: "primary.main" }}
        />
        <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
          {CONGRATULATIONS_MESSAGE}
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions sx={{ justifyContent: "center", pb: 2, px: 3 }}>
      <Button variant="contained" onClick={onClose} fullWidth>
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default DueTodayCongratulationsDialog;
